package com.vizio.redwolf.pay.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class OfferDetailsByOfferIdResponse(
    val offerId: String? = null,
    val status: String? = null,
    val linkCompleteModalHeader: String? = null,
    val linkCompleteModalBody: String? = null
)